import { select } from 'redux-saga/effects';

import * as D from '../../deps';
import { pingKrux } from '../utils';

export function* onListenerAuthenticated({ payload: { authType } }) {
  if (authType === D.Constants.Listener.AuthTypes.RE_AUTH) {
    return;
  }

  const kruxListenerToken = yield select(D.Utils.Listener.getCurrentListenerKruxTokenFromState);
  pingKrux(kruxListenerToken);
}
